import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=65449117&scoped=true"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"
import style0 from "./Stack.vue?vue&type=style&index=0&id=65449117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65449117",
  null
  
)

export default component.exports